//Champ select 
require('./select2.min.js');

if ($("select.mySelect")[0]) {
	var data = ["Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre", "Angola", "Antigua et Barbuda", "Arabie saoudite", "Argentine", "Arménie", "Australie", "Autriche", "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Bélarus", "Belgique", "Belize", "Bénin", "Bhoutan", "Birmanie", "Bolivie", "Bosnie-Herzégovine", "Botswana", "Brésil", "Brunei", "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada", "Cap-Vert", "Chili", "Chine", "Chypre", "Colombie", "Comores", "Congo", "Corée du Nord", "Corée du Sud", "Costa Rica", "Côte d'Ivoire", "Croatie", "Cuba", "Danemark", "Djibouti", "Dominique", "Égypte", "Émirats Arabes Unis", "Équateur", "Érythée", "Espagne", "Estonie", "Eswatini (Swaziland)", "États-Unis", "Éthiopie", "Finlande", "France", "Gabon", "Gambie", "Géorgie", "Ghana", "Grèce", "Grenade", "Guatemala", "Guinée", "Guinée équatoriale", "Guinée-Bissau", "Haïti", "Honduras", "Hong Kong", "Hongrie", "Ile Maurice", "Inde", "Indonésie", "Iran", "Iraq", "Irlande", "Islande", "Israël", "Italie", "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya", "Kirghizistan", "Koweït", "Laos", "Lesotho", "Lettonie", "Liban", "Liberia", "Libye", "Liechtenstein", "Lituanie", "Luxembourg", "Macédoine du Nord", "Madagascar", "Malaisie", "Malawi", "Maldives", "Mali", "Malte", "Maroc", "Mauritanie", "Mexique", "Moldavie", "Monaco", "Mongolie", "Monténégro", "Mozambique", "Namibie", "Népal", "Nicaragua", "Niger", "Nigéria", "Norvège", "Nouvelle-Calédonie", "Nouvelle-Zélande", "Oman", "Ouganda", "Ouzbékistan", "Pakistan", "Panama", "Paraguay", "Pays-Bas", "Pérou", "Philippines", "Pologne", "Porto Rico", "Portugal", "Qatar", "République Centrafricaine", "République Démocratique du Congo", "République Dominicaine", "République Tchèque", "Roumanie", "Royaume-Uni", "Russie", "Rwanda", "Saint Marin", "Salvador", "Samoa", "Sao Tomé-et-Principe", "Sénégal", "Seychelles", "Sierra Leaone", "Singapour", "Slovaquie", "Slovénie", "Somalie", "Soudan", "Soudan du Sud", "Sri Lanka", "Suède", "Suisse", "Syrie", "Tadjikistan", "Taïwan", "Tanzanie", "Tchad", "Thaïlande", "Togo", "Trinité-et-Tobago", "Tunisie", "Turkménistan", "Turquie", "Ukraine", "Union Européenne", "Uruguay", "Vanuatu", "Venezuela", "Viêt Nam", "Yémen", "Zambie", "Zimbabwe"]; // Programatically-generated options array with > 5 options
	var placeholder = "select";
	$(".mySelect").select2({
		data: data,
		placeholder: placeholder,
		allowClear: false,
		minimumResultsForSearch: 5,
		templateSelection: function (data, container) {
    		// Add custom attributes to the <option> tag for the selected option
   			$(data.element).attr('data-custom-attribute', data.customValue);
    		return data.text;
		}
	});

	
	var dmpays;
	$('select.mySelect').on('change', function (e) {
   	 	dmpays = $(this).val();
   	 	dmpays = dmpays.toString();
		dmpays = dmpays.replace(/,/g, ", ");
   	 	$("#organismepays").val(dmpays);
	})


	$("#carddm a").click(function () {
		$("#prestationdepotmarque").click();
		$("#organismenational").click();
		$("#organismepays").val(dmpays);
	});


	/*$('#demdevis').click(function() {
		var selected = $('select.mySelect option:selected');
		console.log(selected.val());
	});*/

}